/**
 * @fileoverview Paint-bucket CSS cursor tinted with the active glaze color.
 * @module paintBucketCursor
 */

/**
 * Returns a CSS `cursor` value showing a paint bucket whose paint drip uses
 * `hex`. The hotspot sits on the tip of the drip.
 * @param {string} hex - e.g. `#2F5F64`
 * @returns {string}
 */
export function paintBucketCursor(hex) {
    const fill = /^#[0-9a-fA-F]{6}$/.test(hex || '') ? hex : '#423837';
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<g stroke="#ffffff" stroke-width="3" stroke-linejoin="round" fill="none">
<path d="M5 13 L15 3 L27 15 L17 25 Z"/><path d="M27 15 C30 19 30 23 28 26 C26 29 23 27 24 24 C25 21 27 18 27 15 Z"/>
</g>
<path d="M5 13 L15 3 L27 15 L17 25 Z" fill="#ffffff" stroke="#423837" stroke-width="1.6" stroke-linejoin="round"/>
<path d="M5 13 L27 15 L17 25 Z" fill="${fill}" stroke="#423837" stroke-width="1.6" stroke-linejoin="round"/>
<path d="M11 1 L11 9" stroke="#423837" stroke-width="1.6" stroke-linecap="round"/>
<path d="M27 15 C30 19 30 23 28 26 C26 29 23 27 24 24 C25 21 27 18 27 15 Z" fill="${fill}" stroke="#423837" stroke-width="1.4"/>
</svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 26 28, crosshair`;
}
